
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import SubscriptionForm from "@/components/SubscriptionForm";

const About = () => {
  return (
    <div className="container py-12 max-w-screen-xl">
      <div className="mb-12">
        <h1 className="mb-6 text-4xl font-bold">About AI Genesis</h1>
        <div className="h-1 w-20 bg-blog-neon shadow-[0_0_10px_rgba(67,255,255,0.5)] rounded-full mb-6"></div>
      </div>
      
      <div className="grid gap-12 lg:grid-cols-2 items-start">
        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-bold mb-4">Our Vision</h2>
            <p className="text-lg text-muted-foreground">
              AI Genesis was created to bridge the gap between cutting-edge artificial intelligence research and everyday applications. We explore the frontiers of AI technology and translate complex concepts into accessible insights for everyone.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
            <p className="text-lg text-muted-foreground">
              Our mission is to provide thoughtful analysis of AI trends, breakthroughs, and applications while fostering a community of learners and enthusiasts. We believe that understanding AI is crucial for navigating our increasingly technological future.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-bold mb-4">Join Our Community</h2>
            <p className="text-lg text-muted-foreground mb-4">
              Whether you're an AI professional, a student, or simply curious about the future of technology, we invite you to join our growing community of readers.
            </p>
            <div className="flex gap-4">
              <Sheet>
                <SheetTrigger asChild>
                  <Button className="bg-blog-neon hover:bg-blog-neon/90">
                    Subscribe
                  </Button>
                </SheetTrigger>
                <SheetContent className="w-[400px] sm:max-w-none">
                  <div className="px-1 py-6">
                    <h2 className="text-2xl font-bold mb-2">Subscribe to AI Genesis</h2>
                    <p className="text-muted-foreground mb-6">
                      Get notified when new articles are published. No spam, unsubscribe anytime.
                    </p>
                    <SubscriptionForm className="max-w-md" />
                  </div>
                </SheetContent>
              </Sheet>
              <Link to="/archive">
                <Button variant="outline" className="border-futuristic-border text-blog-neon hover:bg-blog-neon/10">
                  View Archives
                </Button>
              </Link>
            </div>
          </section>
        </div>
        
        <div className="lg:sticky lg:top-24">
          <div className="overflow-hidden glass-card border-futuristic-border/40 rounded-lg shadow-[0_0_25px_rgba(67,255,255,0.15)]">
            <div className="aspect-video w-full overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1620712943543-bcc4688e7485" 
                alt="AI Technology" 
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold mb-3">Our Team</h3>
              <p className="text-muted-foreground mb-4">
                We are a diverse group of AI researchers, technologists, and writers passionate about the future of artificial intelligence and its impact on society.
              </p>
              <p className="text-muted-foreground">
                Our contributors have backgrounds in machine learning, natural language processing, computer vision, and related fields, bringing a wealth of expertise to our content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
